import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = {
  class: "p-field p-col-12 p-sm-12 p-md-12",
  style: {"alignment":"left"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "quanly" }, " Quản lý việc chuyển giao công nghệ đến các bệnh viện khác", -1)
const _hoisted_4 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "quanly2" }, " Quản lý việc chuyển giao các kỹ thuật theo hợp đồng chuyên môn", -1)
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_7 = {
  key: 0,
  class: "p-field p-col-12 p-sm p-md-6"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "thongtinhopdong" }, "Thông tin hợp đồng:", -1)
const _hoisted_9 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "tenkythuat" }, "Tên kỹ thuật:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "tenkythuat",
  style: {"color":"red"}
}, "(*)", -1)
const _hoisted_12 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "noidung" }, "Nội dung cần chuyển giao:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "noidung",
  style: {"color":"red"}
}, "(*)", -1)
const _hoisted_15 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "ketqua" }, "Kết quả cần đạt được:", -1)
const _hoisted_17 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "songuoi" }, "Số người cần chuyển giao:", -1)
const _hoisted_19 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "thoigian" }, "Thời gian cần thiết để chuyển giao kỹ thuật này:", -1)
const _hoisted_21 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "sobacsi" }, "Số bác sĩ cần thiết để chuyển giao kỹ thuật:", -1)
const _hoisted_23 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_24 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_25 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "hovaten" }, "Họ và tên:", -1)
const _hoisted_27 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "chucvu" }, "Chức vụ:", -1)
const _hoisted_29 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "congtac" }, "Nơi công tác:", -1)
const _hoisted_31 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus-circle" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_35 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "thongtinchuyengiao",
  style: {"margin-right":"4px"}
}, "Thông tin người được chuyển giao kỹ thuật:", -1)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-minus-circle" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "kequachuyengiao" }, "Kết quả chuyển giao:", -1)
const _hoisted_42 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_43 = { class: "p-field p-col-4 p-sm-4 p-md-3" }
const _hoisted_44 = { enctype: "multipart/form-data" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 0,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_47 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_48 = { id: "loading" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", null, "Thêm chỉ đạo mới, vui lòng chờ ...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_lv = _resolveComponent("lv")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thêm thông tin chỉ đạo tuyến" }, {
    default: _withCtx(() => [
      _createVNode(_component_Panel, { header: "Quản lý chỉ đạo tuyến" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("input", {
                type: "radio",
                id: "quanly",
                name: "loaichidao",
                style: {"margin-right":"1vw"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectContact(1)))
              }),
              _hoisted_3
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("input", {
                type: "radio",
                id: "quanly2",
                name: "loaichidao",
                style: {"margin-right":"1vw"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectContact(2)))
              }),
              _hoisted_5
            ])
          ])
        ]),
        _: 1
      }),
      ($setup.showDetail)
        ? (_openBlock(), _createBlock(_component_Panel, {
            key: 0,
            style: {"text-align":"center"},
            header: "Thông tin chi tiết"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                ($setup.hopDong)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_InputText, {
                        id: "thongtinhopdong",
                        type: "text",
                        modelValue: $setup.directingForm.thongtinhd,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.directingForm.thongtinhd) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _createVNode(_component_InputText, {
                    id: "tenkythuat",
                    type: "text",
                    modelValue: $setup.directingForm.tenkt,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.directingForm.tenkt) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _hoisted_14,
                  _createVNode(_component_InputText, {
                    id: "noidung",
                    type: "text",
                    modelValue: $setup.directingForm.noidungcg,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.directingForm.noidungcg) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_InputText, {
                    id: "ketqua",
                    type: "text",
                    modelValue: $setup.directingForm.ketquadd,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.directingForm.ketquadd) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_InputText, {
                    id: "songuoi",
                    type: "text",
                    modelValue: $setup.directingForm.songuoicancg,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.directingForm.songuoicancg) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_InputText, {
                    id: "thoigian",
                    type: "text",
                    modelValue: $setup.directingForm.thoigiancg,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.directingForm.thoigiancg) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_InputText, {
                    id: "sobacsi",
                    type: "text",
                    modelValue: $setup.directingForm.sobacsicg,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.directingForm.sobacsicg) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Panel, {
                    style: {"text-align":"center"},
                    header: "Thông tin về nơi được chuyển giao kỹ thuật"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_InputText, {
                            id: "hovaten",
                            type: "text",
                            modelValue: $setup.directingForm.hovatennoicg,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.directingForm.hovatennoicg) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createVNode(_component_InputText, {
                            id: "chucvu",
                            type: "text",
                            modelValue: $setup.directingForm.chucvunoicg,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.directingForm.chucvunoicg) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createVNode(_component_InputText, {
                            id: "congtac",
                            type: "text",
                            modelValue: $setup.directingForm.noicongtacnoicg,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.directingForm.noicongtacnoicg) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_Panel, {
                    style: {"text-align":"center"},
                    header: "Thông tin về người được chuyển giao"
                  }, {
                    icons: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "p-panel-header-icon p-link p-mr-2",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.addInfo && $setup.addInfo(...args)))
                      }, _hoisted_33)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (lst) => {
                          return (_openBlock(), _createBlock(_component_lv, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("button", {
                                  class: "p-panel-header-icon p-link p-mr-2",
                                  onClick: ($event: any) => ($setup.minusInfo(lst))
                                }, _hoisted_39, 8, _hoisted_37),
                                _createVNode(_component_InputText, {
                                  id: "thongtinchuyengiao",
                                  type: "text",
                                  modelValue: lst.name,
                                  "onUpdate:modelValue": ($event: any) => ((lst.name) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 256))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_InputText, {
                    id: "kequachuyengiao",
                    type: "text",
                    modelValue: $setup.directingForm.ketquacg,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.directingForm.ketquacg) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_Button, {
                  class: "p-button-outlined",
                  label: "Đính kèm tập tin",
                  onclick: "document.getElementById('myFile').click()",
                  icon: "pi pi-paperclip",
                  style: {"margin-right":"5vw"}
                }),
                _createVNode(_component_Button, {
                  label: "Thêm chỉ đạo",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.upload())),
                  icon: "pi pi-plus-circle",
                  disabled: $setup.valid
                }, null, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("form", _hoisted_44, [
                  _createElementVNode("input", {
                    id: "myFile",
                    type: "file",
                    style: {"display":"none"},
                    accept: ".xls,.xlsx,.doc,.docx,.pdf",
                    name: "files",
                    multiple: "multiple",
                    onChange: _cache[15] || (_cache[15] = ($event: any) => ($setup.fileChange($event.target.files))),
                    disabled: $setup.loadingBar
                  }, null, 40, _hoisted_45)
                ])
              ]),
              ($setup.listFileName.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createVNode(_component_DataTable, {
                      value: $setup.listFileName,
                      showGridlines: "",
                      responsiveLayout: "scroll",
                      style: {"font-size":"13px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          field: "nameFile",
                          header: "Tập tin"
                        }),
                        _createVNode(_component_Column, {
                          field: "",
                          header: "",
                          style: {"width":"20px"}
                        }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              class: "p-button-danger",
                              label: "Xóa",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => ($setup.deleteFile(slotProps.data.nameFile)),
                              style: {"font-size":"13px"}
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_Dialog, {
                  header: "Thêm chỉ đạo",
                  visible: $setup.loadingBar,
                  "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => (($setup.loadingBar) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode(_component_ProgressBar, {
                        mode: "indeterminate",
                        style: {"height":".3em"}
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createVNode(_component_ConfirmDialog)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}